/**
 * Espera a que el elemento vídeo tenga un frame listo para mostrar en preview.
 * Evita pantalla en blanco entre permiso concedido y primer frame visible.
 */
export function waitForVideoPreviewReady(
	video: HTMLVideoElement | null | undefined,
	timeoutMs = 8000,
): Promise<void> {
	if (!video) {
		return Promise.resolve();
	}
	if (video.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA && video.videoWidth > 0) {
		return Promise.resolve();
	}
	return new Promise((resolve) => {
		const timeoutId = window.setTimeout(() => {
			video.removeEventListener('loadeddata', onReady);
			resolve();
		}, timeoutMs);
		const onReady = (): void => {
			if (video.videoWidth > 0 || video.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA) {
				window.clearTimeout(timeoutId);
				video.removeEventListener('loadeddata', onReady);
				resolve();
			}
		};
		video.addEventListener('loadeddata', onReady);
	});
}
